'use client'
import { Box, Button, Typography } from '@mui/material'
import {
  errorDescMapper,
  errorTitleMapper,
  TStatusCodes,
} from '../../utility/constants/error'
import { useRouter } from 'next/navigation'

export type TErrorHandleProps = {
  statusCode: TStatusCodes
  name?: string
  className?: string
  buttonClassName?: string
}

export const ErrorHandle = (props: TErrorHandleProps) => {
  const { statusCode } = props
  const router = useRouter()

  const handleComeBack = () => {
    if (statusCode === 401) {
      router.push('/auth/login')
    } else {
      router.back()
    }
  }

  return (
    <Box
      component={'section'}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 'calc(100dvh - 64px)',
      }}
    >
      <Box
        sx={{
          gap: 'var(--spacing_m_nudge)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <Box
          sx={{
            width: '100%',
            m: 'auto',
            maxWidth: '240px',
          }}
        ></Box>
        <Box
          sx={{
            gap: 'var(--spacing__SCF_spacingL)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <Box
            sx={{
              gap: 'var(--spacing__SCF_spacingL)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
            }}
          >
            <Typography variant='BodyLargeMedium' color='text2'>
              {`${errorTitleMapper[statusCode]}`}
            </Typography>

            <Typography variant='BodyLargeMedium' color='text2'>
              {`${errorDescMapper[statusCode]}`}
            </Typography>
          </Box>
          <Button
            variant='contained'
            color='primary'
            onClick={() => handleComeBack()}
          >
            {statusCode === 401 ? 'ورود' : 'بازگشت به صفحه قبل'}
          </Button>
        </Box>
      </Box>
    </Box>
  )
}
